import { useMemo } from "react";
import type { GetPolicyResponse } from "@/openapi/generated/models";
import { isSurchargeDisclaimerPolicy } from "@/features/policies/shared/policy-member-visibility";
import { usePoliciesByUserIdGet } from "./usePoliciesByUserIdGet";

export function findSurchargeDisclaimerPolicy(
  policies: GetPolicyResponse[] | undefined,
): GetPolicyResponse | undefined {
  return policies?.find(isSurchargeDisclaimerPolicy);
}

export function useSurchargeDisclaimerPolicy(userId: number) {
  const query = usePoliciesByUserIdGet({
    userId,
    active: true,
  });

  const policy = useMemo(
    () => findSurchargeDisclaimerPolicy(query.data?.items),
    [query.data?.items],
  );

  return {
    policy,
    isLoading: query.isLoading || query.isPending,
    isError: query.isError,
    refetch: query.refetch,
  };
}
